import { VyIconType } from '@vy/ui-design-system';
import { PHASE_TYPES, PhaseType } from '@vy/types';
import { raiseUnreachable } from '@vy/utils';

export function getLabelIcon(phaseType: PhaseType): VyIconType {
  switch (phaseType) {
    case PHASE_TYPES.RampUp:
      return 'SmallRampUp';
    case PHASE_TYPES.GracePeriod:
      return 'SmallHourglass';
    case PHASE_TYPES.FreeTrial:
      return 'SmallClock';
    case PHASE_TYPES.PriceUpdate:
      return 'SmallCalender';
    case PHASE_TYPES.Milestone:
      return 'SmallMilestone';
    case PHASE_TYPES.Renewal:
      return 'SmallRenewal';
    case PHASE_TYPES.Upsell:
      return 'SmallUpsell';
    case PHASE_TYPES.Standard:
      return 'SmallClock';
    case PHASE_TYPES.AnnualUplift:
      return 'SmallRampUp';
    default:
      return raiseUnreachable(phaseType);
  }
}
